import { ControlledFormSelect } from '@components/formInputs/ControlledFormSelect';
import { LayoutVariant } from '@components/formInputs/sharedTypes';
import { useFormContext } from 'react-hook-form';
import { SettingsOutletHeader } from '../../shared/SettingsOutletHeader';
import { SCHEDULE_OPTIONS } from '../utils/generalSettingsFormHelpers';
import { type GeneralSettingsForm } from '../utils/generalSettingsFormTypes';
import layoutStyles from './ScheduleSection.scss';

const SCHEDULE_SETTINGS_EXPLANATION =
  'Sets the number of days in advance that reservations are available for guests to book. Changing this number does not affect Host-booked or any existing reservations.';

export interface ScheduleSectionProps {
  sectionTitleId: string;
}

export const ScheduleSection = ({ sectionTitleId }: ScheduleSectionProps) => {
  const { control } = useFormContext<GeneralSettingsForm>();

  return (
    <section className={layoutStyles.section} aria-labelledby={sectionTitleId}>
      <SettingsOutletHeader
        variant="section"
        titleId={sectionTitleId}
        title="Schedule"
        subtitle={SCHEDULE_SETTINGS_EXPLANATION}
      />
      <ControlledFormSelect
        control={control}
        label="Publish to Marketplace"
        name="schedule"
        options={SCHEDULE_OPTIONS}
        rules={{ required: true }}
        variant={LayoutVariant.Vertical}
        className={layoutStyles.constrainedField}
      />
    </section>
  );
};
